import React from 'react';
const LocationUpdateConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/nearest-location',
			component: React.lazy(() => import('./LocationUpdate'))
		},
	]
};

export default LocationUpdateConfig;
